<template>
  <button
    type="button"
    class="btn btn--arrow btn--blue btn--fill"
    @click="nextStep"
  ><slot>Continue</slot></button>
</template>

<script>
export default {
  name: 'BtnNextStep',
  methods: {
    nextStep () {
      this.$emit('nextStep')
    }
  }
}
</script>
